import React, { useContext, useEffect, useState } from "react";

import { Back, Hero, LinearGradient, Next } from "../../../../components";

import {
  Container,
  Section,
  Gallery,
  OutlineWrapper,
  Box,
  BoxMobile,
  NavigateButtons,
  RedoButton,
  Modal,
} from "./styles";
import { NavigateButtonsContext, DataUserContext } from "../..";
import { ThemeContext, DefaultTheme } from "styled-components";

import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";
import Memolens from "../../../../assets/common/lens";
import { sendDatalessStep } from "../../../../services/data-service/api";

const Question05: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { token } = useContext(DataUserContext);
  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);
  const [modalUrl, setModalUrl] = useState("");
  const [modal, setModal] = useState(false);
  const [error, setError] = useState(0);

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 6);
  }, []);

  const openModal = (imageUrl) => {
    setModalUrl(imageUrl);
    setModal(true);
  };

  function submit()
  {
    sendDatalessStep('etapa_apresentacao_de_estilo', token);

    next(7);
  }

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_apresentacao_de_estilo.propriedades.imagens.etapa_apresentacao_de_estilo_imagemBanner.url"
            )}
            title={
              can(
                theme,
                "theme.steps.etapa_apresentacao_de_estilo.propriedades.conteudo.estilo.titulo"
              ) || "Não encontrado"
            }
            superscript={can(
              theme,
              "theme.steps.etapa_apresentacao_de_estilo.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p className="answer">
              {can(
                theme,
                "theme.steps.etapa_apresentacao_de_estilo.propriedades.conteudo.estilo.titulo"
              )}
            </p>

            <img
              src={can(
                theme,
                "theme.steps.etapa_apresentacao_de_estilo.propriedades.conteudo.estilo.imagem_principal"
              )}
              alt=""
              className="result"
            />

            <p className="description">
              {can(
                theme,
                "theme.steps.etapa_apresentacao_de_estilo.propriedades.conteudo.estilo.texto"
              ) || ""}
            </p>

            <Gallery>
              {theme.steps.etapa_apresentacao_de_estilo.propriedades.conteudo.estilo?.imagens_galeria.map(
                (url, index) => (
                  <>
                    <div className="box" onClick={() => openModal(url)}>
                      <div className="lens">
                        <Memolens />
                      </div>
                      <img src={url} alt="" key={index} />
                    </div>
                    {modal && (
                      <div
                        className="outside-close"
                        onClick={() => setModal(false)}
                      >
                        <Modal onClick={(e) => e.stopPropagation()}>
                          <img src={modalUrl} alt="" key={index} />
                        </Modal>
                      </div>
                    )}
                  </>
                )
              )}
            </Gallery>

            <OutlineWrapper>
              <Box>
                {/* <span className="superscript">
                  Vamos manifestar sua personalidade e
                </span> */}
                <span className="title">
                  Vamos falar mais sobre seu projeto?
                </span>
              </Box>
            </OutlineWrapper>

            <p className="try-again">
              <b>Achou que o resultado não combina muito com você?</b> <br />
              Sem problemas, vamos tentar novamente
            </p>

            <RedoButton onClick={() => next(2)}>Refazer o teste</RedoButton>            
            
            <BoxMobile>
              <span className="title">
                Vamos falar mais sobre seu projeto?
              </span>
            </BoxMobile>
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question05;
